import { getProvidersCache, setProviders } from 'localStorage/dataStorage';
import { axiosErrorHandler, get } from 'models/shared/helpers/axiosInstance';
import { Provider } from '../interfaces/provider.interface';

const basePath = '/v1/providers';

export const getProviders = async (
	onlyActive = true,
	forceRefresh = false,
): Promise<Provider[]> => {
	try {
		if (onlyActive && !forceRefresh) {
			const cached = getProvidersCache();
			if (cached) return cached;
		}
		const url = onlyActive ? `${basePath}?onlyActive=true` : basePath;
		const res = await get<Provider[]>(url);
		if (onlyActive) setProviders(res.data);
		return res.data;
	} catch (err) {
		throw axiosErrorHandler(err);
	}
};
